module.exports = __webpack_public_path__ + "img/18.512b7949.png";